var fn = function( obj ){
var __t,__p='';
__p+='\n\n#if __VERSION__ == 300\n  #define IN in\n  out vec4 FragColor;\n  #define texture2D(a,b) texture( a, b )\n#else\n  #define IN varying\n  #define FragColor gl_FragColor\n#endif\n\nuniform sampler2D tInput;\nIN vec2 vTexCoordVP;\nIN vec2 vTexCoordFull;\n\n#if NEED_DEPTH\n  uniform sampler2D tDepth;\n#endif\n\n\n#if TEXTURE_DEPTH\n  float FETCH_DEPTH( sampler2D t, vec2 uvs ){\n    return texture2D(t,uvs).x;\n  }\n#else\n  \n  highp float decodeDepthRGB(highp vec3 rgb){\n    return(rgb.x+rgb.y*(1.0/255.0))+rgb.z*(1.0/65025.0);\n  }\n\n  float FETCH_DEPTH( sampler2D t, vec2 uvs ){\n    return decodeDepthRGB( texture2D(t,uvs).xyz );\n  }\n#endif\n\n\n\nvec3 sRGB( vec3 c )\n{\n  return c * ( c * ( c*0.305306011 + vec3(0.682171111) ) + vec3(0.012522878) );\n}\n\nfloat luminance( vec3 c )\n{\n  return dot( c, vec3(0.3,0.59,0.11) );\n}\n\n\n\n'+
(obj.precode)+
'\n\n\nvoid main(void){\n  vec3 c;\n\n  vec2 texCoordVP   = vTexCoordVP;\n  vec2 texCoordFull = vTexCoordFull;\n\n\n  #if NEED_DEPTH\n    float sceneDepth = FETCH_DEPTH( tDepth, texCoordVP );\n  #endif\n\n  '+
(obj.code)+
'\n\n  FragColor.xyz=c;\n  FragColor.w=1.0;\n\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
